import React from "react";

const CatWalkRobertonOutline = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='361.667'
      height='540.505'
      fillRule='nonzero'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      clipRule='evenodd'
      version='1.1'
      viewBox='0 0 361.667 540.505'
      xmlSpace='preserve'
      className='clickable'
    >
      <g
        fill='rgba(0,0,0,0)'
        className='object-glow'
        stroke='#ff5c97'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='5'
        transform='translate(-2359.111 -1347.098)'
      >
        <path
          d='M2588.6 1351c-9.33 1.87-17.73 4.9-25.2 9.1-7.47 4.2-16.1 11.2-25.9 21-9.8 9.8-19.13 20.3-28 31.5-8.87 11.2-15.87 14.93-21 11.2-5.13-3.73-13.53-12.6-25.2-26.6-11.67-14-23.8-25.43-36.4-34.3-12.6-8.87-20.53-13.3-23.8-13.3-3.27 0-6.3 1.17-9.1 3.5s-7 9.33-12.6 21-9.1 23.57-10.5 35.7c-1.4 12.13 3.27 30.57 14 55.3 10.73 24.73 18.43 43.87 23.1 57.4 4.67 13.53 7.93 24.03 9.8 31.5 1.87 7.47 3.03 17.97 3.5 31.5.47 13.53-.93 27.77-4.2 42.7-3.27 14.93-10.97 34.3-23.1 58.1-12.13 23.8-20.3 41.77-24.5 53.9-4.2 12.13-6.77 21.7-7.7 28.7-.93 7 1.63 15.4 7.7 25.2 6.07 9.8 14.7 21.47 25.9 35 11.2 13.53 20.77 23.8 28.7 30.8s15.63 12.6 23.1 16.8c7.47 4.2 13.53 6.77 18.2 7.7 4.67.93 10.97.93 18.9 0 7.93-.93 18.2-3.73 30.8-8.4 12.6-4.67 26.13-8.87 40.6-12.6 14.47-3.73 36.63-11.43 66.5-23.1 29.87-11.67 50.87-20.77 63-27.3 12.13-6.53 20.3-12.13 24.5-16.8 4.2-4.67 4.9-14.7 2.1-30.1-2.8-15.4-10.97-39.43-24.5-72.1-13.53-32.67-21.47-55.77-23.8-69.3-2.33-13.53-2.33-25.67 0-36.4 2.33-10.73 11.43-33.83 27.3-69.3 15.87-35.47 24.5-55.77 25.9-60.9 1.4-5.13 1.87-11.67 1.4-19.6-.47-7.93-2.57-14.93-6.3-21s-11.2-14.47-22.4-25.2c-11.2-10.73-23.1-19.83-35.7-27.3-12.6-7.47-24.27-12.13-35-14-10.73-1.87-20.77-1.87-30.1 0z'
          opacity='1'
        ></path>
        <path d='M2493 1426l-25 455' opacity='1'></path>
        <path d='M2491 1467s12-.06 12 8c0 9-13 8-13 8' opacity='1'></path>
        <path d='M2489 1529.97s12-.07 12 8c0 9-13 8-13 8' opacity='1'></path>
        <path d='M2487 1594s12-.06 12 8c0 9-13 8-13 8' opacity='1'></path>
        <path d='M2482 1668s12-.06 12 8c0 9-13 8-13 8' opacity='1'></path>
        <path d='M2478 1745.97s12-.07 12 8c0 9-13 8-13 8' opacity='1'></path>
        <path d='M2474 1815s12-.06 12 8c0 9-13 8-13 8' opacity='1'></path>
      </g>
    </svg>
  );
}

export default CatWalkRobertonOutline;
